import React, { useState } from 'react'
import styled from 'styled-components'

import { TREE } from '../consts'
import { Tree } from '../types'
import Intro from './Intro'
import Step from './Step'

const Container = styled.div`
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  display: flex;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  width: 100%;
  min-width: 320px;
  max-width: 500px;
  height: 100%;
  min-height: 600px;
  flex: 1;
`

type Status =
  | { tag: 'intro' }
  | { tag: 'step'; tree: Tree; prevStatus: Status; stepIdx: number }

const App: React.FC = () => {
  const [status, setStatus] = useState<Status>({ tag: 'intro' })

  return (
    <Container>
      <Content>
        {status.tag === 'intro' && (
          <Intro
            onPressStart={() =>
              setStatus({
                tag: 'step',
                tree: TREE,
                prevStatus: { tag: 'intro' },
                stepIdx: 0,
              })
            }
          />
        )}
        {status.tag === 'step' && (
          <Step
            tree={status.tree}
            idx={status.stepIdx}
            onPressNext={nextTree =>
              setStatus({
                tag: 'step',
                tree: nextTree,
                prevStatus: status,
                stepIdx: status.stepIdx + 1,
              })
            }
            onPressPrev={() => setStatus(status.prevStatus)}
            onPressBackToIntro={() => setStatus({ tag: 'intro' })}
          />
        )}
      </Content>
    </Container>
  )
}

export default App
